export var defaultData = {
    ardabil: {
        germi: 0,
        parsabad: 0,
        bilehsavar: 0,
        meshginshahr: 0,
        namin: 0,
        ardabil: 0,
        sareyn: 0,
        nir: 0,
        khalkhal: 0,
        kowsar: 0,
    },
    isfahan: {
        khurandbiabanak: 0,
        nain: 0,
        ardestan: 0,
        aranandbidgol: 0,
        kashan: 0,
        natanz: 0,
        isfahan: 0,
        borkhar: 0,
        najafabad: 0,
        mobarakeh: 0,
        shahreza: 0,
        dehaqan: 0,
        semirom: 0,
        fereydunshahr: 0,
        chadegan: 0,
        faridan: 0,
        lenjan: 0,
        tiranandkarvan: 0,
        buinandmiandasht: 0,
        khansar: 0,
        golpayegan: 0,
        shahinshahrandmeymeh: 0,
        khomeynishahr: 0,
        falavarjan: 0,
    },
    alborz: {
        taleqan: 0,
        karaj: 0,
        savojbolagh: 0,
        nazarabad: 0,
        eshtehard: 0,
        fardis: 0,
    },
    bushehr: {
        deylam: 0,
        ganaveh: 0,
        dashtestan: 0,
        bushehr: 0,
        tangestan: 0,
        dashti: 0,
        deyr: 0,
        asaluyeh: 0,
        jam: 0,
        kangan: 0,
    },
    chaharmahalandBakhtiari: {
        kuhrang: 0,
        ardal: 0,
        lordegan: 0,
        kiar: 0,
        borujen: 0,
        farsan: 0,
        shahrekord: 0,
        saman: 0,
        ben: 0,
    },
    eastAzerbaijan: {
        charuymaq: 0,
        maragheh: 0,
        hashtrud: 0,
        malekan: 0,
        bonab: 0,
        ajabshir: 0,
        mianeh: 0,
        sarab: 0,
        bostanabad: 0,
        heris: 0,
        osku: 0,
        azarshahr: 0,
        tabriz: 0,
        shabestar: 0,
        varzaqan: 0,
        maarand: 0,
        jolfa: 0,
        khodaafarin: 0,
        ahar: 0,
        kaleybar: 0,
    },
    fars: {
        larestan: 0,
        darab: 0,
        zarindasht: 0,
        neyriz: 0,
        bavanat: 0,
        estahban: 0,
        fasa: 0,
        jahrom: 0,
        lamerd: 0,
        gerash: 0,
        khonj: 0,
        mohr: 0,
        qirandkarzin: 0,
        farashband: 0,
        firuzabad: 0,
        kavar: 0,
        sarvestan: 0,
        kharameh: 0,
        shiraz: 0,
        kazerun: 0,
        arsanjan: 0,
        khorambid: 0,
        abadeh: 0,
        eqlid: 0,
        rostam: 0,
        mamasani: 0,
        marvdasht: 0,
        ardakan: 0,
        pasargad: 0,
    },
    gilan: {
        astara: 0,
        talesh: 0,
        rezvanshahr: 0,
        masal: 0,
        bandaranzali: 0,
        sowmeehsara: 0,
        fuman: 0,
        shaft: 0,
        rasht: 0,
        rudbar: 0,
        siahkal: 0,
        astanehyeashrafiyeh: 0,
        lahijan: 0,
        langarud: 0,
        rudsar: 0,
        amlash: 0,
    },
    golestan: {
        maravehtapeh: 0,
        kalaleh: 0,
        galikash: 0,
        minudasht: 0,
        azadshahr: 0,
        ramian: 0,
        aliabad: 0,
        gorgan: 0,
        kordkuy: 0,
        bandaregaz: 0,
        torkaman: 0,
        gomishan: 0,
        aqqala: 0,
        gonbadekavus: 0,
    },
    hamadan: {
        malayer: 0,
        nahavand: 0,
        tuyserkan: 0,
        asadabad: 0,
        bahar: 0,
        hamadan: 0,
        famenin: 0,
        razan: 0,
        kabudarahang: 0,
    },
    hormozgan: {
        parsian: 0,
        bandarlengeh: 0,
        bastak: 0,
        khamir: 0,
        bandarabas: 0,
        hajiabad: 0,
        rudan: 0,
        minab: 0,
        sirik: 0,
        jask: 0,
        qeshm: 0,
        bashagard: 0,
    },
    ilam: {
        dehloran: 0,
        mehran: 0,
        malekshahi: 0,
        darehshahr: 0,
        badreh: 0,
        eyvan: 0,
        ilam: 0,
        chardavol: 0,
    },
    kerman: {
        qalehganj: 0,
        rudbarejonub: 0,
        rigan: 0,
        fahraj: 0,
        manujan: 0,
        kahnuj: 0,
        anbarabad: 0,
        faryab: 0,
        bam: 0,
        narmashir: 0,
        kerman: 0,
        jiroft: 0,
        arzuiyeh: 0,
        baft: 0,
        rabor: 0,
        bardsir: 0,
        ravar: 0,
        kuhbanan: 0,
        zarand: 0,
        rafsanjan: 0,
        sirjan: 0,
        anar: 0,
        shahrebabak: 0,
    },
    kermanshah: {
        gilanegharb: 0,
        ghasreshirin: 0,
        eslamabadegharb: 0,
        kermanshah: 0,
        harsin: 0,
        kangavar: 0,
        sahneh: 0,
        songhor: 0,
        ravansar: 0,
        paveh: 0,
        javanrud: 0,
        dalahu: 0,
        salasebabajani: 0,
        sarpolezahab: 0,
    },
    khuzestan: {
        andimeshk: 0,
        dezful: 0,
        shush: 0,
        dashteazadegan: 0,
        hoveyzeh: 0,
        gotvand: 0,
        lali: 0,
        andika: 0,
        izeh: 0,
        masjedsoleyman: 0,
        shushtar: 0,
        hamidiyeh: 0,
        ahvaz: 0,
        bavi: 0,
        haftkel: 0,
        baghemalek: 0,
        ramhormoz: 0,
        ramshir: 0,
        aghajari: 0,
        bandaremahshahr: 0,
        behbahan: 0,
        hendijan: 0,
        omidiyeh: 0,
        karun: 0,
        khoramshahr: 0,
        abadan: 0,
        shadegan: 0,
    },
    kohgiluyehAndBoyerAhmad: {
        gachsaran: 0,
        basht: 0,
        choram: 0,
        boyerahmad: 0,
        dana: 0,
        kohgiluyeh: 0,
        landeh: 0,
        bahmai: 0,
    },
    kurdistan: {
        ghorveh: 0,
        dehgolan: 0,
        kamyaran: 0,
        sanandaj: 0,
        sarvabad: 0,
        marivan: 0,
        bijar: 0,
        divandareh: 0,
        saghez: 0,
        baneh: 0,
    },
    lorestan: {
        aligudarz: 0,
        azna: 0,
        dorud: 0,
        borujerd: 0,
        khoramabad: 0,
        selseleh: 0,
        delfan: 0,
        poldokhtar: 0,
        dowreh: 0,
        rumeshkan: 0,
        kuhdasht: 0,
    },
    markazi: {
        zarandieh: 0,
        saveh: 0,
        tafresh: 0,
        komijan: 0,
        khondab: 0,
        shazand: 0,
        khomeyn: 0,
        mahalat: 0,
        delijan: 0,
        ashtian: 0,
        farahan: 0,
        arak: 0,
    },
    mazandaran: {
        galugah: 0,
        behshahr: 0,
        neka: 0,
        miandorud: 0,
        sari: 0,
        savadkuh: 0,
        northsavadkuh: 0,
        ghaemshahr: 0,
        juybar: 0,
        simorgh: 0,
        babolsar: 0,
        babol: 0,
        amol: 0,
        nur: 0,
        noshahr: 0,
        chalus: 0,
        kelardasht: 0,
        abasabad: 0,
        tonekabon: 0,
        ramsar: 0,
        fereydunkenar: 0,
        mahmudabad: 0,
    },
    northKhorasan: {
        esfarayn: 0,
        faruj: 0,
        shirvan: 0,
        bojnord: 0,
        jajarm: 0,
        garmeh: 0,
        manehandsamalqan: 0,
        razandjargalan: 0,
    },
    qazvin: {
        buinzahra: 0,
        avaj: 0,
        takestan: 0,
        abyek: 0,
        alborz: 0,
        qazvin: 0,
    },
    qom: { qom: 0 },
    razaviKhorasan: {
        dargaz: 0,
        quchan: 0,
        neyshabur: 0,
        chenaran: 0,
        binalud: 0,
        mashhad: 0,
        khoshab: 0,
        firuzeh: 0,
        jowayin: 0,
        davarzan: 0,
        joghatai: 0,
        sabzevar: 0,
        kalat: 0,
        sarakhs: 0,
        fariman: 0,
        bardaskan: 0,
        bajestan: 0,
        kashmar: 0,
        gonabad: 0,
        torbatejam: 0,
        torbateheydarieh: 0,
        zaveh: 0,
        roshtkhar: 0,
        bakhraz: 0,
        khvaf: 0,
        taybad: 0,
        mahvelat: 0,
        khalilabad: 0,
    },
    semnan: {
        shahrud: 0,
        damghan: 0,
        semnan: 0,
        sorkheh: 0,
        aradan: 0,
        garmsar: 0,
        meyami: 0,
        mehdishahr: 0,
    },
    sistanAndBaluchestan: {
        hirmand: 0,
        zahak: 0,
        nimruz: 0,
        hamun: 0,
        zabol: 0,
        zahedan: 0,
        mirjaveh: 0,
        khash: 0,
        iranshahr: 0,
        saravan: 0,
        mehrestan: 0,
        dalgan: 0,
        sibandsuran: 0,
        sarbaz: 0,
        fanuj: 0,
        nikshahr: 0,
        chabahar: 0,
        konarak: 0,
        qasreqand: 0,
    },
    southKhorasan: {
        nehbandan: 0,
        sarbisheh: 0,
        darmian: 0,
        zirkuh: 0,
        qaenat: 0,
        birjand: 0,
        khusf: 0,
        tabas: 0,
        sarayan: 0,
        ferdows: 0,
        boshruyeh: 0,
    },
    tehran: {
        malard: 0,
        shahriar: 0,
        robatkarim: 0,
        baharestan: 0,
        eslamshahr: 0,
        qods: 0,
        tehran: 0,
        rey: 0,
        varamin: 0,
        pishva: 0,
        qarchak: 0,
        pakdasht: 0,
        damavand: 0,
        pardis: 0,
        shemiranat: 0,
        firuzkuh: 0,
    },
    westAzerbaijan: {
        maku: 0,
        chaldoran: 0,
        showt: 0,
        poldasht: 0,
        chaypareh: 0,
        khoy: 0,
        salmas: 0,
        urmia: 0,
        naqadeh: 0,
        oshnavieh: 0,
        piranshahr: 0,
        sardasht: 0,
        mahabad: 0,
        bukan: 0,
        shahindezh: 0,
        takab: 0,
        miandoab: 0,
    },
    yazd: {
        khatam: 0,
        mehriz: 0,
        taft: 0,
        abarkuh: 0,
        bafq: 0,
        yazd: 0,
        ashkezar: 0,
        meybod: 0,
        ardakan: 0,
        behabad: 0,
    },
    zanjan: {
        tarom: 0,
        zanjan: 0,
        mahneshan: 0,
        ijrud: 0,
        soltaniyeh: 0,
        abhar: 0,
        khodabandeh: 0,
        khoramdareh: 0,
    },
};
//# sourceMappingURL=defaultData.js.map